import { Popover } from "react-tiny-popover";
import { regexUrlMatch } from "../../../services/helpers/Helper";
import { Link, useLocation } from "react-router-dom";
import { useState } from "react";

const ItemMenu = (props) => {
   const location = useLocation();
   const [isShow, setIsShow] = useState(false);
   return (
      <Popover
         isOpen={isShow}
         align={'center'}
         positions={['right', 'bottom']}
         clickOutsideCapture={true}
         content={<div className="app-tooltip app-messaging-first-tooltip app-tooltip-placement-right" style={{ marginTop: -15 }}>
            <div className="app-tooltip-content">
               <div className="app-tooltip-arrow"></div>
               <div className="app-tooltip-inner" role="tooltip">{props.tooltip}</div>
            </div>
         </div>}
      >
         <li className="app-messaging-first--nav-link-item" onMouseLeave={() => setIsShow(false)} onMouseEnter={() => setIsShow(true)}>
            <Link
               className={`app-messaging-first--nav-link-item ${props.name} ${regexUrlMatch(props.match, location.pathname) && "app-messaging-first--nav-link-item--active"}`}
               to={props.href}>
               <span>
                  <div className="app-messaging-first--nav-link-item--icon">
                     {props.icon}
                  </div>
               </span>
            </Link>
         </li>
      </Popover>
   )
}

export default ItemMenu;